import { DefaultUrlSerializer, UrlSerializer, UrlTree } from '@angular/router';

/**
 * Angular treats ( and ) in URL paths as named router outlet syntax.
 * Stop IDs may contain these characters (e.g. "Marina Grande (arrivo)").
 * This serializer percent-encodes them in path segments so they are treated
 * as plain data, not outlet delimiters.
 */
export class SafeUrlSerializer implements UrlSerializer {
  private default = new DefaultUrlSerializer();

  parse(url: string): UrlTree {
    return this.default.parse(this.encodePath(url));
  }

  serialize(tree: UrlTree): string {
    return this.encodePath(this.default.serialize(tree));
  }

  private encodePath(url: string): string {
    const [path, ...rest] = url.split('?');
    const safePath = path
      .split('/')
      .map(seg => seg.replace(/\(/g, '%28').replace(/\)/g, '%29'))
      .join('/');
    return rest.length ? `${safePath}?${rest.join('?')}` : safePath;
  }
}
